var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeedOfLife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fe0fa7f1-bc8b-46a2-b58e-547f9282723a",
    "data-name": "bd086145-5706-47ec-a429-33164f2e1bfc",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 501.8 501.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b04fdd9a-7c1a-40aa-a05d-6755bc3f67c5{fill:none;stroke:#d99938;stroke-miterlimit:10;stroke-width:8px;}.b0d499c1-1b9c-4040-88f8-641e826c1f0d{fill:#d99938;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b04fdd9a-7c1a-40aa-a05d-6755bc3f67c5",
    cx: 250.9,
    cy: 374.3,
    r: 123.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b04fdd9a-7c1a-40aa-a05d-6755bc3f67c5",
    cx: 250.9,
    cy: 252.5,
    r: 123.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "b04fdd9a-7c1a-40aa-a05d-6755bc3f67c5",
    cx: 250.9,
    cy: 127.5,
    r: 123.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "b04fdd9a-7c1a-40aa-a05d-6755bc3f67c5",
    cx: 357.9,
    cy: 189.5,
    r: 123.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "b04fdd9a-7c1a-40aa-a05d-6755bc3f67c5",
    cx: 356.9,
    cy: 314.5,
    r: 123.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "b04fdd9a-7c1a-40aa-a05d-6755bc3f67c5",
    cx: 144.9,
    cy: 188.5,
    r: 123.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "b04fdd9a-7c1a-40aa-a05d-6755bc3f67c5",
    cx: 143.9,
    cy: 313.5,
    r: 123.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b0d499c1-1b9c-4040-88f8-641e826c1f0d",
    d: "M251.9,246.4c-37-60,0-112,0-112"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b0d499c1-1b9c-4040-88f8-641e826c1f0d",
    d: "M248.9,370.3c37.6-59.6,1.2-112,1.2-112"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b0d499c1-1b9c-4040-88f8-641e826c1f0d",
    d: "M256.1,248.2c33.9-61.8,97.3-55.3,97.3-55.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b0d499c1-1b9c-4040-88f8-641e826c1f0d",
    d: "M352.9,310.4c-32.5-62.6-96.8-56.3-96.8-56.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b0d499c1-1b9c-4040-88f8-641e826c1f0d",
    d: "M244.4,254.9c-33.9,61.8-97.4,55.3-97.4,55.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b0d499c1-1b9c-4040-88f8-641e826c1f0d",
    d: "M148.4,192c32.8,62.4,97.1,55.8,97.1,55.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedOfLife);
export default __webpack_public_path__ + "static/media/seed_of_life.a6453fec.svg";
export { ForwardRef as ReactComponent };